/**
 * Cấp ngân sách
 */
export default {
  Center: 1,
  Province: 2,
  District: 3,
  Ward: 4,
};
